import {useSearchParams} from 'next/navigation'
import {redirectQueryParam, webAppAuthQueryParam} from 'notability-services-common-universal'
import {useExperimentValues} from 'notability-services-next-frontend'

export function useIsWebAppUser() {
  const searchParams = useSearchParams()
  const experimentValues = useExperimentValues()
  const redirectParam = searchParams.get(redirectQueryParam)
  if (redirectParam) {
    return redirectParam === webAppAuthQueryParam
  } else {
    return experimentValues.webAppSignupsEnabled && experimentValues.webAppMarketingEnabled
  }
}
